export default [
    {
        path: '/cooperate/andy',
        name: 'AndyCooperate',
        component: () => import('@/views/Cooperate/Andy/Andy.vue'),
        meta: {
            layout: 'single-page'
        }
    },
    {
        path: '/cooperate/playwhat',
        name: 'PlayWhatCooperate',
        component: () => import('@/views/Cooperate/Kimi/Kimi.vue'),
        meta: {
            layout: 'single-page'
        }
    },
]